import type { FC } from 'react';
import type { ProjectData, CaseStudyProps } from '../data-projects';

export const Mobilisights: FC<ProjectData & CaseStudyProps> = ({ cta }) => {
  return (
    <>
      <section>
        <h3>14 disparate automotive brands causing data fragmentation across continents</h3>
        <h4>The Push for Change</h4>
        <p>
          Stellantis acquired an existing platform as the foundation for Mobilisights, their data business unit tasked with unifying APIs across 14 global automotive brands. The inherited platform architecture could not support the data demands of 15 million connected vehicles across North America and Europe.
        </p>
        <p>
          Legacy infrastructure limitations prevented real-time data processing capabilities, creating bottlenecks that would impact service delivery to enterprise clients requiring immediate insights from continental-scale vehicle fleets.
        </p>
      </section>
      <section id="solution">
        <h3>Zero-downtime migration strategy preserving business continuity</h3>
        <h4>Shaping Solutions from Technology</h4>
        <p>
          Platform modernization required seamless integration of 14 disparate automotive brand APIs while maintaining continuous service availability. The solution involved comprehensive infrastructure upgrades, performance optimization, and large-scale data migration processes executed without service interruption.
        </p>
        <p>
          Critical technical challenges included real-time data pipeline architecture for processing vehicle telemetry, implementing scalable storage solutions, and ensuring data consistency across multi-continental operations. The platform now supports near real-time analytics for mobility insights across diverse automotive ecosystems.
        </p>
      </section>
      <section id="results">
        <h3>15M connected vehicles delivering actionable insights across two continents</h3>
        <h4>Delivering Lasting Results</h4>
        <p>
          Platform transformation enabled Mobilisights to process 30TB of monthly data influx with zero service downtime during migration. The unified platform now connects enterprise clients with real-time insights from 15 million vehicles across 14 automotive brands, establishing Mobilisights as a leader in mobility data services.
        </p>
        <p>
          Infrastructure improvements delivered enhanced system reliability and consistent service delivery, positioning Mobilisights for market expansion and integration of additional automotive brands as the connected vehicle ecosystem evolves.
        </p>
      </section>
      {cta}
    </>
  );
};
